import { render, staticRenderFns } from "./ResellerService.vue?vue&type=template&id=1f52032c&"
import script from "./ResellerService.vue?vue&type=script&lang=js&"
export * from "./ResellerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f52032c')) {
      api.createRecord('1f52032c', component.options)
    } else {
      api.reload('1f52032c', component.options)
    }
    module.hot.accept("./ResellerService.vue?vue&type=template&id=1f52032c&", function () {
      api.rerender('1f52032c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Reseller/ResellerService.vue"
export default component.exports